import React, { Component } from 'react'
import { ebgreen, footer_gray, green, maxwidth, pink } from '../../constants'
import Teams_slider from '../Teams_slider/Teams_slider'
import teams from '../../images/teams.png'
import logo from '../../images/logoslogan.png'
import location from '../../images/location.png'
import mail from '../../images/mail.png'
import call from '../../images/call.png'
import whatsapp from '../../images/whatsapp.png'
import eblogo from '../../images/eblogo.png'
import { FaCartArrowDown, FaFacebook, FaInstagram, FaLinkedin, FaSearch, FaTwitter, FaYoutube } from "react-icons/fa";
import './Footer.css'
import { Link } from 'react-scroll'

class Footer extends Component {
    
    render() {
        const handleclick=()=>{
            const link="https://drive.google.com/file/d/1Xp-PJsVtK7eiU8Y6HhiMek20viEvHw0P/view?usp=sharing";
            window.open(link, '_blank', 'noreferrer');
        }
        return (
            <div id='contact' className='footer-outer-container'>
                <div className='footer-inner-container'>
                    <div className='footer-subone'>
                    <Link to="home" spy={true} smooth={true} offset={-100} duration={100}><img src={logo} height="200px" style={{cursor:"pointer"}}></img></Link>
                        
                        <ul style={{ fontSize: "13px", listStyle: "none", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", textDecoration: "none", gap: "5px", marginTop: "10px" ,paddingLeft:"0px"}}>

                            <li className='navbar_item' ><Link to="home" spy={true} smooth={true} offset={-100} duration={100} style={{color:pink,textDecoration:"none"}} >Home</Link></li>
                            <span style={{ color: pink }}>|</span>
                            <li className='navbar_item' ><Link to="about" spy={true} smooth={true} offset={-150} duration={100} style={{color:pink,textDecoration:"none"}}>About</Link></li>
                            <span style={{ color: pink }}>|</span>
                            <li className='navbar_item' ><Link to="focus" spy={true} smooth={true} offset={-150} duration={100} style={{color:pink,textDecoration:"none"}}>Focus</Link></li>
                            <span style={{ color: pink }}>|</span>
                            <li className='navbar_item' ><Link to="salaamstree" spy={true} smooth={true} offset={-100} duration={100} style={{color:pink,textDecoration:"none"}}>Salaam Stree</Link></li>
                            
                        </ul>
                    </div>

                    <div className='footer-subtwo' >
                        <div style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center" }}>
                            <div><img src={location} ></img></div>

                            <span>Registered office: 36, Harasidhdhi Nagar,
                                Panadesara, Surat, Gujarat - 394221 (India)</span>
                        </div>
                        <div style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center" }}>
                            <div><img src={mail}></img></div>

                            <span>streesafety@gmail.com</span>
                        </div>
                        <div style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center" }}>
                            <div><img src={call}></img></div>

                            <span>+1 (385) 528-8026</span>
                        </div>
                        <div style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center" }}>
                            <div><img src={whatsapp}></img></div>

                            <span>+91 95860 12231</span>
                        </div>
                    </div>

                    <div className='footer-subthree'></div>

                    <div className='footer-subfour'>
                        <span style={{ fontWeight: "600" }}>About Empower Bharat Training Ltd.</span>

                        <span style={{ fontSize: "13px", marginTop: "10px", marginBottom: "15px" }}>Empower Bharat-”An Initiative to Revive Rural India '',
                            launched on India’s 75th Independence Day with the
                            vision to bridge the Rural-Urban economic divide at
                            grass-root level by child education, youth employment,
                            and women safety training.
                        </span>

                        <Link to='' onClick={handleclick}><img src={eblogo} height="60px" style={{cursor:"pointer"}}></img></Link>

                        <span style={{ marginTop: "5px",fontSize:"13px" }}>Follow us on our social media:</span>

                        <ul style={{ listStyle: "none", display: "flex", flexDirection: "row", textDecoration: "none", gap: "30px", alignItems: "start", marginTop: "20px", padding: "0px" }}>

                            <a href='https://twitter.com/BharatEmpower' target='_blank' style={{ textDecoration: "none" }}> <FaTwitter style={{ fontSize: "35px", color: ebgreen }}></FaTwitter> </a>
                            <a href='https://www.facebook.com/empower.bharat26/' target='_blank' style={{ textDecoration: "none" }}> <FaFacebook style={{ fontSize: "35px", color: ebgreen }}></FaFacebook> </a>
                            <a href='https://www.instagram.com/empower_bharat/ ' target='_blank' style={{ textDecoration: "none" }}> <FaInstagram style={{ fontSize: "35px", color: ebgreen }}></FaInstagram> </a>
                            <a href='https://youtube.com/channel/UCOsrIOTD25RQcSRQkYDfegQ' target='_blank' style={{ textDecoration: "none" }}> <FaYoutube style={{ fontSize: "35px", color: ebgreen }}></FaYoutube> </a>
                            <a href='https://www.linkedin.com/company/empower-bharat' target='_blank' style={{ textDecoration: "none" }}> <FaLinkedin style={{ fontSize: "35px", color: ebgreen }}></FaLinkedin> </a>

                        </ul>
                    </div>
                </div>
                <div className='copy-right'>
                    <span >Copyright 2023, Empower Bharat Training Ltd. | All rights reserved | Terms & Conditions</span>
                </div>
            </div>
        )
    }
}

export default Footer
